import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/whatsapp";

export const FloatingWhatsApp = () => (
    <motion.a
        href={waLink("general")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Falar no WhatsApp"
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.4, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-[#25D366] p-4 text-[#052e12] shadow-[0_10px_36px_rgba(37,211,102,0.4)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#2ce06f]"
    >
        <span className="beacon-dot absolute inset-0 -z-10 rounded-full bg-[#25D366]/40" aria-hidden="true" />
        <MessageCircle size={24} strokeWidth={2.5} />
        <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-bold transition-all duration-500 group-hover:ml-2.5 group-hover:max-w-[180px]">
            Falar no WhatsApp
        </span>
    </motion.a>
);
